import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { OneloginService } from '../../service';

export type SuperUsersConfig = typeof SuperUsersConfig._.Config;

export const SuperUsersConfig = IntegrationConfig.make({
  service: OneloginService,
  name: Integration_Handler_Names_Enum.SuperUsers,
  configSchema: z.object({}),
});
